<overlay-loading-spinner-border *ngIf="isPdfLoading()" [show]="isPdfLoading" />
<overlay-loading-spinner-border *ngIf="isSaveBtnClicked()" [show]="isSaveBtnClicked" />

<ng-container *transloco="let t;">
    <div class="row mb-2">
        <div class="col me-auto">
            <h3>{{schemaName}}</h3>
        </div>
        <div class="col-lg-auto col-12">
            <div id="schema-info-action-button">
                <button class="btn btn wp-btn-outline d-flex justify-content-center align-items-center" type="button"
                    data-bs-toggle="collapse" data-bs-target="#schemaInfo" aria-controls="schemaInfo"
                    [attr.aria-expanded]="schemaIsPatient">
                    <svg class="icon icon-primary icon-sm me-2">
                        <use xlink:href="assets/icons.svg#icon-info-circle"></use>
                    </svg>
                    <span>{{ t("schema.schemainfo") }}</span>
                </button>
            </div>
        </div>
    </div>

    <div class="mb-3" [ngClass]="{'collapse': schemaIsPatient,'show': !schemaIsPatient}" id="schemaInfo">
        <div *ngIf="schemaInfo" class="content-box">
            <div class="row mb-3">
                <div class="col-md-6 mb-3">
                    <div class="mb-2">
                        <div class="fw-semibold">{{ t("schema.tableheader.patient")}}</div>
                        <span>
                            {{ schemaInfo.patientName+" " + schemaInfo.patientSurname
                            + " ("+displayedPatientCpr+")" }}
                        </span>
                    </div>
                    <div class="row g-2">
                        <div class="col-auto align-content-center">
                            <i class="fa-solid fa-user-pen"></i>
                        </div>
                        <div class="col">
                            {{ schemaInfo.sentCount > 0
                            ? t("schema.tableheader.dataenteredby")
                            : t("schema.tableheader.dataenterer")}}
                            {{ schemaInfo.dataEnteredBy| schemaDataEnterer | async }}
                        </div>
                    </div>
                    <div *ngIf="schemaInfo.assisterName" class="mb-2">
                        <i class="fa fa-circle-info text-danger"></i>
                        {{ schemaInfo.assisterName }} {{ t("schema.tableheader.assister") }}
                    </div>

                </div>
                <div class="col-md-6">
                    <div class="mb-2">
                        <div class="fw-semibold">{{ t("schema.tableheader.createdby") }}</div>
                        <div>{{ schemaInfo.doctorOrganization }}</div>
                    </div>
                    <div class="row g-2">
                        <div class="col-auto align-content-center">
                            <i class="fa-regular fa-file-lines"></i>
                        </div>
                        <div class="col">
                            <div>{{ t("schema.tableheader.createdat") }}
                                {{ schemaInfo.createdDate | date : "dd-MM-yyyy" }}
                            </div>
                        </div>
                    </div>
                    <div class="row g-2">
                        <div class="col-auto align-content-center">
                            <i class="fa-regular fa-calendar-check"></i>
                        </div>
                        <div class="col">
                            <div>{{ t("schema.tableheader.validfrom")}} {{ schemaInfo.validFrom | date :
                                "dd-MM-yyyy" }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <hr>

            <div class="row gy-md-0 gy-2">
                <div class="col-sm-6">
                    <small [ngClass]="getStatusClass(schemaInfo.schemaInfoStatus)"
                        class="px-2 py-1 fw-medium border rounded-2 d-block d-md-inline">
                        {{ t("schema.tableheader.status")}}:
                        <br class="d-sm-none" />
                        <span>
                            {{ schemaInfo.schemaInfoStatus | schemaInfoStatus | async }}
                        </span>
                    </small>
                </div>
                <div class="col-sm-6">
                    <div class="row g-2">
                        <div class="col-auto align-content-center">
                            <i class="fa-regular fa-clock text-warning"></i>
                        </div>
                        <div class="col">
                            <div>{{ t("schema.tableheader.latestanswer")}}
                                {{ schemaInfo.validTo | date :"dd-MM-yyyy" }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div id="sticky-form-header" class="content-box position-sticky top-0 mb-3">
        <div class="row gx-2 gy-2 gy-md-0 justify-content-end">
            <div class="col-auto is-desktop" id="guidance-action-button">
                <button type="button" class="btn wp-btn-outline" (click)="goToGuide()"
                    [disabled]="!formioData.guidanceUrl">
                    <svg class="icon icon-primary icon-sm me-2">
                        <use xlink:href="assets/icons.svg#icon-file-text"></use>
                    </svg>
                    <span>{{ t("schema.schemaactions.guide") }}</span>
                </button>
            </div>
            <div class="col-auto is-desktop" id="pdf-action-button">
                <button type="button" class="btn wp-btn-outline" (click)="onGetPdf()" [disabled]="isPdfLoading()">
                    <svg class="icon icon-primary icon-sm me-2">
                        <use xlink:href="assets/icons.svg#icon-file-pdf"></use>
                    </svg>
                    <span>{{ t("schema.schemaactions.print")}}</span>
                </button>
            </div>
            <div class="col-auto" [hidden]="(schemaIsPatient && schemaIsSent) || isReadOnly" id="save-action-button">
                <button type="button" class="btn wp-btn-outline" (click)="saveSchemaClick()"
                    [disabled]="isSchemaSaving()">
                    <svg class="icon icon-primary icon-sm me-2">
                        <use xlink:href="assets/icons.svg#icon-save"></use>
                    </svg>
                    <span>{{ t("schema.schemaactions.save") }}</span>
                </button>
            </div>
            <div class="col-auto" [hidden]="(schemaIsPatient && schemaIsSent) || isReadOnly" id="send-action-button">
                <button type="button" class="btn wp-btn" (click)="handleSendClick()" [disabled]="isSchemaSending()">
                    <svg class="icon icon-dark-bg icon-sm me-2">
                        <use xlink:href="assets/icons.svg#icon-paper-plane"></use>
                    </svg>
                    <span>{{ t("schema.schemaactions.sendschema") }}</span>
                </button>
            </div>
            <ng-container *ngIf="schemaIsPatient === false && !schemaIsSent">
                <div class="col-auto is-desktop" id="delete-action-button">
                    <button type="button" class="btn btn-outline-danger" data-bs-toggle="modal"
                        data-bs-target="#deleteSchemaDialog" [disabled]="isSchemaDeleting()">
                        <svg class="icon icon-danger icon-sm me-2">
                            <use xlink:href="assets/icons.svg#icon-delete"></use>
                        </svg>
                        <span>{{ t("schema.schemaactions.deleteschema") }}</span>
                    </button>
                </div>
            </ng-container>

            <div class="col-auto is-mobile" id="more-actions-btn-dropdown">
                <div class="dropdown">
                    <button class="btn wp-btn-outline" type="button" id="schemaActionsMenu" data-bs-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <i class="fa-solid fa-ellipsis"></i>
                        <span class="visually-hidden">Flere handlinger</span>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="schemaActionsMenu" role="menu">
                        <li role="none">
                            <button type="button" class="dropdown-item d-flex align-items-center" role="menuitem"
                                (click)="goToGuide()" [disabled]="!formioData.guidanceUrl"
                                [disabled]="!formioData.guidanceUrl">
                                <svg class="icon icon-primary icon-sm me-2">
                                    <use xlink:href="assets/icons.svg#icon-file-text"></use>
                                </svg>
                                <span>{{ t('schema.schemaactions.guide') }}</span>
                            </button>
                        </li>
                        <li role="none">
                            <button type="button" class="dropdown-item d-flex align-items-center" role="menuitem"
                                (click)="onGetPdf()" [disabled]="isPdfLoading()" [attr.aria-disabled]="isPdfLoading()">
                                <svg class="icon icon-primary icon-sm me-2">
                                    <use xlink:href="assets/icons.svg#icon-file-pdf"></use>
                                </svg>
                                <span>{{ t('schema.schemaactions.print') }}</span>
                            </button>
                        </li>
                        <ng-container *ngIf="schemaIsPatient === false && !schemaIsSent">
                            <li role="separator" class="dropdown-divider"></li>
                            <li role="none">
                                <button type="button" class="dropdown-item text-danger d-flex align-items-center"
                                    role="menuitem" data-bs-toggle="modal" data-bs-target="#deleteSchemaDialog"
                                    [disabled]="isSchemaDeleting()" [attr.aria-disabled]="isSchemaDeleting()">
                                    <svg class="icon icon-danger icon-sm me-2">
                                        <use xlink:href="assets/icons.svg#icon-delete"></use>
                                    </svg>
                                    <span>{{ t('schema.schemaactions.deleteschema') }}</span>
                                </button>
                            </li>
                        </ng-container>
                    </ul>
                </div>

            </div>

        </div>
    </div>


    <div class="content-box">
        <formio [attr.style]="formioData.style" [form]="formioData.formIoJson" [submission]="formioData.answerJson"
            [renderOptions]="{ sanitizeConfig: { addTags: ['datatitle'], addAttr: ['datatitle'] }, language: 'da',
                i18n:{da:{'January': 'Januar', 'February': 'Februar', 'March': 'Marts', 'May': 'Maj', 'June': 'Juni',
                'July': 'Juli', 'October': 'Oktober', 'Month': 'Måned', 'Year': 'År', 'Save': 'Gem',
                'Do you want to clear changes?': 'Vil du slette dine ændringer?', 'Cancel': 'Afbryd', 'Yes, delete it'
                : 'Ja'
                }}}" (nextPage)="onChangePage()" (prevPage)="onChangePage()" (submit)="onSubmit($event)"
            (change)="onChange($event)" (customEvent)="onCustomEvent($event)" [readOnly]="isReadOnly"
            [refresh]="refreshFormEvent" #formioInstance>
        </formio>
    </div>

    <div class="modal fade" id="sendSchemaDialog" role="dialog" aria-labelledby="sendSchemaDialogLabel"
        data-bs-backdrop="static" tabindex="-1">
        <send-schema-dialog [formioData]="this.formioData" [formSubmission]="this.submission"
            [isSchemaSending]="isSchemaSending" [formIoComponent]="this.formComponent" />
    </div>

    <div class="modal fade" id="deleteSchemaDialog" role="dialog" aria-labelledby="deleteSchemaDialogLabel"
        data-bs-backdrop="static" tabindex="-1">
        <delete-schema-dialog [formioData]="this.formioData" [isSchemaDeleting]="isSchemaDeleting"
            (deleteSchemaEvent)="handleToastContent($event)" />
    </div>

    <div *ngIf="getIsSchemaAwaiting()" class="modal fade" id="readOnlySchemaDialog" role="dialog"
        aria-labelledby="readOnlySchemaDialogLabel" data-bs-backdrop="static">
        <readonly-schema-dialog [readonly]="getIsSchemaAwaiting()" />
    </div>

    <div class="toast-container position-fixed bottom-0 end-0 p-3">
        <div id="saveSchemaToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="toast-header">
                <strong class="me-auto">{{schemaName}}</strong>
                <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
            <div *ngIf="schemaToast" class="toast-body d-flex align-items-center">
                <svg *ngIf="schemaToast.status == schemaStatus.SUCCESS" class="icon-primary icon-md b me-2">
                    <use xlink:href="assets/icons.svg#icon-info-circle"></use>
                </svg>
                <svg *ngIf="schemaToast.status == schemaStatus.ERROR" class="icon-danger icon-md b me-2">
                    <use xlink:href="assets/icons.svg#icon-circle-x"></use>
                </svg>
                <span *ngIf="schemaToast">{{schemaToast.text}}</span>
            </div>
        </div>
    </div>

    <div class="toast-container position-fixed bottom-0 end-0 p-3">
        <div id="deleteSchemaToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="toast-header">
                <strong class="me-auto">{{schemaName}}</strong>
                <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
            </div>
            <div *ngIf="schemaToast" class="toast-body d-flex align-items-center">
                <svg *ngIf="schemaToast.status == schemaStatus.SUCCESS" class="icon-danger icon-md b me-2">
                    <use xlink:href="assets/icons.svg#icon-delete"></use>
                </svg>
                <svg *ngIf="schemaToast.status == schemaStatus.ERROR" class="icon-warning icon-md b me-2">
                    <use xlink:href="assets/icons.svg#icon-delete"></use>
                </svg>
                <span [ngClass]="{
                        'text-danger': schemaToast.status == schemaStatus.SUCCESS,
                        'text-warning': schemaToast.status == schemaStatus.ERROR
                }">
                    {{schemaToast.text}}
                </span>
            </div>
        </div>
    </div>

</ng-container>